import { render, staticRenderFns } from "./userList.vue?vue&type=template&id=427f5612&scoped=true"
import script from "./userList.vue?vue&type=script&lang=js"
export * from "./userList.vue?vue&type=script&lang=js"
import style0 from "./userList.vue?vue&type=style&index=0&id=427f5612&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427f5612",
  null
  
)

export default component.exports